import { Avatar, Box } from "@material-ui/core";
import { Tooltip, Link } from "@mui/material";
import isoCountries from "i18n-iso-countries";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { ReactComponent as FilterIcon } from "../../../src/assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../src/assets/Customer/FilterIconHover.svg";
import { ReactComponent as CreateIcon } from "../../../src/assets/USA_Images/CreateIcon.svg";
import ViewIcon from "../../Pages/Invitations/ViewIcon";
import CommonUtil from "../../Util/CommonUtils";
import { REACT_CREATE_CUSTOMER } from "../../actions/EndPoints";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import HeaderToolbar from "../../components/HeaderToolbar";
import Toast from "../../components/ToastContainer/CustomToast";
import { exportCustomerLogs } from "../../services/Invitations/ExportDealerService";
import {
  fetchCustomersDetailsByDealerCompanyId,
  resendActivationLink,
} from "../../slices/Customer/CustomerSlice";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import ExportDialog from "../DailyReports/ExportDialog";
import ResendIcon from "../Invitations/ResendIcon";
import EditIcon from "../Person/EditIcon";
import CustomerDownload from "./CustomerDownload";
import CustomerFilter from "./CustomerFilter";
import DeleteCustomer from "./DeleteCustomer";

function CustomersList() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [clear, setClear] = React.useState(false);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [openFilter, setOpenFilter] = useState(false);
  const [openDownload, setOpenDownload] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [openEditCustomer, setopenEditCustomer] = useState(false);
  const [editRowData, setEditRowDate] = useState({});
  const [openDeleteCustomer, setOpenDeleteCustomer] = useState(false);
  const [customerId, setCustomerId] = useState();
  const [customer, setCustomer] = useState();
  const [customerName, setCustomerName] = useState();
  const [searchRecord, setSearchRecord] = useState();
  const [loading, setLoading] = useState(true);
  const [parentCompanyCountry, setParentCompanyCountry] = useState("");
  const [fileFormat, setFileFormat] = useState("1");
  const [noOfRecords, setNoOfRecords] = useState("0");
  const [inputValue, setInputValue] = useState("");
  const [toInputValue, setToInputValue] = useState("");
  const [isLivePhoto, setIsLivePhoto] = useState(false);
  const [isSignature, setIsSignature] = useState(false);
  const [closemodel, setClosemodel] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const resetFilter = () => {
    setLoading(true);
    setClear(false);
    setPaging({ ...paging, pageNumber: 1 });
    setfilter(defaultFilter);
    setLoading(true);
  };

  const handleChange = (newPage, size) => {
    setLoading(true);
    setPage(newPage);
    setPaging({
      pageNumber: newPage,
      pageSize: size,
    });
  };

  const [defaultFilter, setDefaultFilter] = useState({
    status: "",
    name: "",
    email: "",
    subscriptionName: "",
    subscriptionStartDate: "",
    subscriptionEndDate: "",
  });

  const [filter, setfilter] = useState({
    status: "",
    name: "",
    email: "",
    subscriptionName: "",
  });

  const [paging, setPaging] = useState({
    pageNumber: "1",
    pageSize: "50",
  });

  const handleFilter = (data) => {
    setLoading(true);
    setClear(true);
    setfilter({
      ...filter,
      status: data.status,
      name: data.name,
      email: data.email,
      subscriptionName: data.subscriptionName,
    });
  };

  const handleFileFormatChange = (event) => {
    setFileFormat(event.target.value);
  };

  const handleDataRecordsChange = (event) => {
    setNoOfRecords(event.target.value);
  };

  const handleCheckBoxLivePhoto = (event) => {
    setIsLivePhoto(event.target.checked);
  };
  const handleCheckBoxSignature = (event) => {
    setIsSignature(event.target.checked);
  };
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setInputValue(value);
    }
  };

  const handleToInputChange = (event) => {
    const value = event.target.value;
    if (
      /^\d*$/.test(value) &&
      (value === "" ||
        (parseInt(value, 10) > 0 && parseInt(value, 10) <= 10000))
    ) {
      setToInputValue(value);
    }
  };

  const handleExportCustomer = (data) => {
    if (fileFormat == "2") {
      setIsLivePhoto(false);
      setIsSignature(false);
    }
    var searchParam = "";
    if (filter.name !== undefined && !CommonUtil.isEmptyString(filter.name)) {
      searchParam += "&name=" + encodeURIComponent(filter.name);
    }
    if (filter.email !== undefined && !CommonUtil.isEmptyString(filter.email)) {
      searchParam += "&email=" + encodeURIComponent(filter.email);
    }
    if (
      filter.subscriptionName !== undefined &&
      !CommonUtil.isEmptyString(filter.subscriptionName)
    ) {
      searchParam +=
        "&subscriptionName=" + encodeURIComponent(filter.subscriptionName);
    }
    if (
      filter.status !== undefined &&
      !CommonUtil.isEmptyString(filter.status)
    ) {
      searchParam += "&status=" + filter.status;
    }

    const stats = {
      fileType: fileFormat,
      from: inputValue === "" ? "0" : inputValue,
      to: toInputValue === "" ? "0" : toInputValue,
    };

    dispatch(exportCustomerLogs(onSuccess, onFailure, stats, searchParam))
      .unwrap()
      .then((data) => {
        if ((data.code = "CVAI0000" && data.data)) {
          onSuccess();
        } else {
          onFailure();
        }
      })
      .catch((er) => { });
  };

  const onSuccess = () => {
    setClosemodel(true);

    return Toast(t("EXPORTSUCC001"), "success");
  };

  const onFailure = () => {
    Toast(t("COMMON000"), "error");
  };

  const handleResendAccountActivate = (params) => {
    dispatch(resendActivationLink(params))
      .unwrap()
      .then((data) => {
        switch (data.code) {
          case "CVAI0001":
            Toast(t("DEALERRESENDACTIVEEMAIL"), "success");
            break;
          case "MSGE4006":
            Toast(t("DEALERCHECKACTIVEEMAILNOT"), "error");
            break;
          default:
            Toast(data.message, "error");
            break;
        }
      })
      .catch((e) => { });
  };

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging]);

  const getCountryCodeFromName = (countryName) => {
    const formattedCountryName = countryName
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase());
    const countryCode = (
      isoCountries.getAlpha2Code(formattedCountryName, "en") || ""
    ).toLowerCase();
    return countryCode || null;
  };

  const loadData = (filter, paging) => {
    const payload = {
      pageNumber: paging.pageNumber,
      pageSize: paging.pageSize,
      status: filter.status,
      name: filter.name,
      email: filter.email,
      subscriptionName: filter.subscriptionName,
    };
    dispatch(fetchCustomersDetailsByDealerCompanyId(payload))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4024") {
          setLoading(false);
          setRows(res.data.companies);
          setTotalRecords(res.data.totalCount);
          setPage(res.data.currentPage);
          setTotalPages(res.data.totalPages);
        }
      });
  };

  const handleDeleteCustomer = (params) => {
    setOpenDeleteCustomer(!openDeleteCustomer);
    setCustomerId(params.id);
    setCustomerName(params.name);
    setCustomer(params);
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 20) {
      return text.substring(0, 20) + "...";
    } else {
      return text;
    }
  };

  const testBackGroundColors = [
    "#C7D4E7",
    "#F8EACD",
    "#DBE1D7",
    "#EBD3E1",
    "#E2DEED",
    "#EBD3D3",
    "#D7EEE8",
    "#D3F5D5",
    "#E5D9C3",
    "#D2C785",
    "#C6E0E3",
    "#E4D8EB",
    "#D0D1DC",
    "#CCE1D8",
    "#CBDAEC",
    "#F6FCE1",
    "#F6FCE1",
    "#DBD0CE",
    "#C3DFCF",
    "#E6D8E5",
    "#C3EBE1",
    "#C0E5F5",
    "#EBE3B1",
    "#F6CFCF",
    "#ECD4E9",
    "#D5F6CF",
    "#DAD9F5",
    "#F2E1CB",
  ];

  const textColors = [
    "#2D4568",
    "#6C5629",
    "#2F4B1C",
    "#491D37",
    "#20163B",
    "#572626",
    "#214C42",
    "#275E2B",
    "#7D6845",
    "#677820",
    "#29666D",
    "#4E2168",
    "#1E203A",
    "#194130",
    "#143F70",
    "#586E0C",
    "#392871",
    "#543935",
    "#395847",
    "#6D3969",
    "#085341",
    "#1E3C4A",
    "#3E380D",
    "#481515",
    "#381434",
    "#163610",
    "#13123E",
    "#30210E",
  ];

  const getAvatarColor = (name) => {
    const colors = [
      "#C7D4E7",
      "#F8EACD",
      "#DBE1D7",
      "#EBD3E1",
      "#E2DEED",
      "#EBD3D3",
      "#D7EEE8",
      "#D3F5D5",
      "#E5D9C3",
      "#D2C785",
      "#C6E0E3",
      "#E4D8EB",
      "#D0D1DC",
      "#CCE1D8",
      "#CBDAEC",
      "#F6FCE1",
      "#F6FCE1",
      "#DBD0CE",
      "#C3DFCF",
      "#E6D8E5",
      "#C3EBE1",
      "#C0E5F5",
      "#EBE3B1",
      "#F6CFCF",
      "#ECD4E9",
      "#D5F6CF",
      "#DAD9F5",
      "#F2E1CB",
    ];
    const index =
      name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
      colors.length;
    return colors[index];
  };

  const ZoomHandaler = (params) => {
    const { name, imagePreSignedURL } = params.row;

    const getColorIndex = (name) => {
      const total = name
        .toUpperCase()
        .split("")
        .reduce((sum, char) => sum + char.charCodeAt(0), 0);
      return total % testBackGroundColors.length;
    };
    // Get initials
    const initials = `${name?.charAt(0) || ""}`;
    const bgColor = !imagePreSignedURL
      ? getAvatarColor(initials)
      : "transparent";
    const colorIndex = getColorIndex(initials);
    const textColor = imagePreSignedURL ? "inherit" : textColors[colorIndex];

    return (
      <SimpleDialogDemo
        button={
          <Avatar
            style={{
              cursor: "pointer",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={name}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
        child={
          <Avatar
            style={{
              width: "300px",
              height: "300px",
              border: "1px solid #FFFF",
              fontSize: "100px",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: bgColor,
              color: textColor,
            }}
            alt={name}
            src={imagePreSignedURL || undefined}
          >
            {!imagePreSignedURL && initials.toUpperCase()}
          </Avatar>
        }
      />
    );
  };

  const handleEdit = (params) => {
    setEditRowDate(params);
    setopenEditCustomer(true);
    history.push({
      pathname: "/vis/createCustomer",
      state: params,
      country: parentCompanyCountry,
    });
  };

  const handleView = (params) => {
    history.push({
      pathname: "/vis/viewCustomerDetails",
      state: params,
    });
  };

  const columns = React.useMemo(() => [
    {
      field: "company.profile",
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return ZoomHandaler(params);
      },
    },

    {
      field: "companyName",
      headerName: t("CUSTDATABLE01"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.name,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "email",
      headerName: t("CUSTDATABLE02"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.email,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "mobile",
      headerName: t("CUSTDATABLE03"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.phone,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "adminName",
      headerName: t("CUSTDATABLE04"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.adminName,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "subscription",
      headerName: t("CUSTDATABLE05"),
      flex: 1,
      minWidth: 190,
      valueGetter: (params) => params.row.subscriptionName,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "status",
      headerName: t("CUSTDATABLE07"),
      flex: 1,
      minWidth: 140,
      valueGetter: (params) => params.row.status,
      renderCell: (params) => (
        <Tooltip title={`${params.value}`} placement="bottom-start">
          <span>{handleTextOverflow(params.value)}</span>
        </Tooltip>
      ),
    },

    {
      field: "Actions",
      headerName: t("CUSTDATABLE16"),
      type: "actions",
      flex: 1,
      minWidth: 205,
      width: 150,
      headerAlign: "center",
      getActions: (params) => [
        <Box onClick={() => handleView(params.row)}>
          <ViewIcon />
        </Box>,

        <Box onClick={() => handleEdit(params.row)}>
          <EditIcon />
        </Box>,
          <Box onClick={() => handleResendAccountActivate(params.row)}>
            <ResendIcon toolTip={true} />
          </Box>,
      ],
    },
  ]);

  const handleFilterIcon = () => {
    setOpenFilter(true);
  };

  const handleCreateCustomer = () => {
    history.push({
      pathname: REACT_CREATE_CUSTOMER,
      country: parentCompanyCountry,
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <HeaderToolbar title={t("DASHBOARDTABCUSTOMER")} />

      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        gap="5px"
        style={{
          padding: "10px 0px 10px 10px",
        }}
      >
        <Tooltip title={t("COMMON006")}>
          <Box
            item
            className={"filter"}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleFilterIcon}
          >
            {isHovered ? (
              <FilterIconHover style={{ color: "#474a4e" }} />
            ) : (
              <FilterIcon style={{ color: "#474a4e" }} />
            )}
          </Box>
        </Tooltip>
        <Box item style={{ margin: "0 2px" }}>
          <ExportDialog
            rowsPerPage={rowsPerPage}
            applyFilter={(data) => handleExportCustomer(data)}
            totalRecords={totalRecords}
            nameTitle={"Export Customer"}
            handleFileFormatChange={handleFileFormatChange}
            handleDataRecordsChange={handleDataRecordsChange}
            handleInputChange={handleInputChange}
            handleToInputChange={handleToInputChange}
            fileFormat={fileFormat}
            noOfRecords={noOfRecords}
            inputValue={inputValue}
            toInputValue={toInputValue}
            setFileFormat={setFileFormat}
            setNoOfRecords={setNoOfRecords}
            setInputValue={setInputValue}
            setToInputValue={setToInputValue}
            setIsLivePhoto={setIsLivePhoto}
            setIsSignature={setIsSignature}
            isLivePhoto={isLivePhoto}
            isSignature={isSignature}
            handleCheckBoxLivePhoto={handleCheckBoxLivePhoto}
            handleCheckBoxSignature={handleCheckBoxSignature}
            dealerPortal={true}
            closemodel={closemodel}
            setClosemodel={setClosemodel}
          />
        </Box>

        <Tooltip title={t("ADDCUSTOMER")}>
          <Box item className={"addIcon"} onClick={handleCreateCustomer}>
            <CreateIcon />
          </Box>
        </Tooltip>

        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "0.8",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={resetFilter}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>

      </Box>

      <div style={{ height: 300, width: "100%" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>

      {openFilter && (
        <CustomerFilter
          open={openFilter}
          applyFilter={handleFilter}
          handleClose={() => {
            setOpenFilter(false);
          }}
        />
      )}

      {openDownload && (
        <CustomerDownload
          open={openDownload}
          handleClose={() => {
            setOpenDownload(false);
          }}
          filter={filter}
        />
      )}

      {openDeleteCustomer && (
        <DeleteCustomer
          open={openDeleteCustomer}
          handleDialogClose={handleClose}
          loadData={() => {
            loadData(filter, paging);
          }}
          handleClose={(data) => {
            setOpenDeleteCustomer(data);
          }}
          customerId={customerId}
          customerName={customerName}
          customer={customer}
        />
      )}
    </>
  );
}
export default CustomersList;
